import { useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Skeleton from '@mui/material/Skeleton';

import { ListHomeEventsQuery, ListHomeSpotsQuery } from '@graphql';
import { SlidersWrapper } from '@components';
import Slider from './Slider';
import { SlideSkeleton } from './Slide';

interface SlidersProps {
  categories: ListHomeEventsQuery['eventCategories'] | ListHomeSpotsQuery['homeSpots'];
}

export const Sliders = (props: SlidersProps) => {
  const { categories } = props;
  const theme = useTheme();

  const isLoading = categories.length === 0;

  return (
    <SlidersWrapper sx={{ position: 'relative' }}>
      {/* SKELETON */}
      <Stack
        sx={{
          position: 'absolute',
          inset: 0,
          opacity: isLoading ? 1 : 0,
          pointerEvents: isLoading ? 'auto' : 'none',
          transition: 'opacity 400ms ease-out',
          // display none after animation
          ...(isLoading
            ? {}
            : {
                display: 'none',
              }),
        }}
      >
        <Stack justifyContent="center" alignItems="center" width="100%" height="auto">
          {new Array(8).fill(null).map((_, index) => (
            <Stack
              key={index}
              justifyContent="center"
              alignItems="flex-start"
              width="100%"
              height="auto"
              p={2}
            >
              <Skeleton
                variant="rectangular"
                animation="wave"
                width={getWith(30, 70)}
                height={30}
                sx={{ borderRadius: theme.spacing(0.5), mb: 2 }}
              />

              <Stack
                width="100%"
                direction="row"
                spacing={1}
                height="auto"
                sx={{
                  overflowX: 'scroll',
                  scrollBehavior: 'smooth',
                  '&::-webkit-scrollbar': { display: 'none' },
                  msOverflowStyle: 'none',
                }}
              >
                {new Array(8).fill(null).map((_, i) => (
                  <Stack key={i} sx={{ flexShrink: 0 }}>
                    <SlideSkeleton />
                  </Stack>
                ))}
              </Stack>
            </Stack>
          ))}
        </Stack>
      </Stack>

      {/* DATA */}
      <Stack
        spacing={5}
        sx={{
          opacity: isLoading ? 0 : 1,
          transform: isLoading ? 'translateY(8px)' : 'translateY(0)',
          transition: 'opacity 500ms ease-out, transform 300ms ease-out',
        }}
      >
        {categories.map((category) => (
          <Slider key={category.id} category={category} />
        ))}
      </Stack>
    </SlidersWrapper>
  );
};

// get radom with between min and max
function getWith(min: number, max: number) {
  return `${Math.floor(Math.random() * (max - min + 1)) + min}%`;
}
